import React, { useEffect, useRef, useState } from "react";
import "../pages/PurchaseOrders.css";

interface Props {
  title: string;
  kicker: string;
  hint: string;
  confirmText: string;
  busy: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

const I = {
  close: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6 6 18" /></svg>,
};

/** Ret / iptal gerekçesi (misafire iletilir, boş bırakılabilir). Randevu kartının üstünde açılır. */
const AppointmentReasonModal: React.FC<Props> = ({ title, kicker, hint, confirmText, busy, onClose, onSubmit }) => {
  const [reason, setReason] = useState("");
  const [opener] = useState(() => document.activeElement as HTMLElement | null);
  const ref = useRef<HTMLTextAreaElement | null>(null);

  const submit = (e?: React.FormEvent) => {
    e?.preventDefault();
    if (busy) return;
    onSubmit(reason.trim());
  };

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) { e.stopPropagation(); onClose(); }
      else if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) { e.preventDefault(); submit(); }
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClose, busy, reason]);

  useEffect(() => () => { if (opener && opener.isConnected) opener.focus?.({ preventScroll: true }); }, [opener]);
  useEffect(() => { ref.current?.focus(); }, []);

  return (
    <div className="po-overlay center top" onMouseDown={(e) => { if (e.target === e.currentTarget && !busy) onClose(); }}>
      <form className="po-modal" role="dialog" aria-modal="true" aria-labelledby="ap-reason-title" onSubmit={submit}>
        <div className="po-modal-head">
          <div><span className="po-kicker">{kicker}</span><h3 id="ap-reason-title">{title}</h3></div>
          <button type="button" className="po-ib big" aria-label="Kapat" onClick={onClose} disabled={busy}>{I.close}</button>
        </div>
        <div className="po-modal-body">
          <label className="po-field">
            <span>Gerekçe<em>misafire iletilir, boş bırakılabilir</em></span>
            <textarea ref={ref} rows={3} maxLength={300} value={reason} placeholder={hint} onChange={(e) => setReason(e.target.value)} />
          </label>
          <span className="po-counter">{reason.length}/300</span>
        </div>
        <div className="po-modal-foot">
          <button type="button" className="po-btn" onClick={onClose} disabled={busy}>Vazgeç</button>
          <button type="submit" className="po-btn primary danger" disabled={busy}>{busy ? "Gönderiliyor" : confirmText}</button>
        </div>
      </form>
    </div>
  );
};

export default AppointmentReasonModal;
